import clsx from 'clsx'

import { Text } from '@wartek-id/text-v1'

import Badge from '../Badge'

import type { BadgeColor } from '../Badge'
import type { KinerjaPraktikPembelajaranContentIndikator } from 'types/kinerja'

interface CardIndikatorDimensiProps extends React.HTMLProps<HTMLDivElement> {
  indikator: KinerjaPraktikPembelajaranContentIndikator
  icon?: React.ReactNode
  dimension: string
  recommended?: boolean
  isDisabled?: boolean
  isSelected?: boolean
  onSelected?: (selected: boolean) => void
  color?: BadgeColor
}

export default function CardIndikatorDimensi({
  indikator,
  dimension,
  icon,
  recommended = false,
  isDisabled = false,
  isSelected = false,
  onSelected = () => {},
  color = 'default',
  className,
  ...divProps
}: CardIndikatorDimensiProps) {
  const cardClasses = clsx(
    className,
    'max-w-[282px] select-none border border-subdued rounded-lg',
    'hover:border-gray-30 hover:bg-blue',
    {
      '!bg-blue-5 !border-blue-70': isSelected,
      'cursor-pointer': !isDisabled,
    }
  )

  const handleClick = () => {
    if (isDisabled) return

    onSelected(!isSelected)
  }

  return (
    <div
      aria-selected={isSelected}
      className={cardClasses}
      data-testid="card"
      role="option"
      onClick={handleClick}
      {...divProps}
    >
      <div className="flex flex-col gap-2 p-4 h-full">
        <div className="flex justify-end min-h-[36px] -mt-4">
          {recommended && (
            <div className="inline-flex rounded-tr-md rounded-bl-md p-2 pl-3 bg-[color:var(--color-surface-informational-subdued)] -mr-4">
              <Text variant="body-sm" className="!text-blue-60">
                Rekomendasi
              </Text>
            </div>
          )}
        </div>

        {icon}

        <Text variant="heading-sm">{indikator.nama}</Text>

        <Text color="subdued" className="flex-1">
          {indikator.definisi}
        </Text>

        <div>
          <Badge text={`Dimensi: ${dimension}`} color={color} />
        </div>
      </div>
    </div>
  )
}
